import { useEffect, useState } from "react";
import { useLogin } from "../../hooks/useLogin";
import { useSelector } from "react-redux";
import { onAuthStateChanged } from "firebase/auth";
import { logining } from "../../features/userSlice";
import { useDispatch } from "react-redux";
import { auth } from "../../firebase/config";

import CSS from "./CSS.module.css";

const Dashboard = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { error, login } = useLogin();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();
    login(email, password);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const userData = {
          uid: user.uid,
          email: user.email,
          displayName: user.displayName,
        };
        dispatch(logining(userData));
      }
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [dispatch]);

  return (
    <main className={CSS.main}>
      <h1>Login</h1>
      {!user && (
        <form onSubmit={handleSubmit}>
          <label>
            <input
              required
              type="email"
              placeholder="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
          <label>
            <input
              required
              type="password"
              placeholder="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
          <button type="submit">Log In</button>
          {error && <p>{error}</p>}
        </form>
      )}
    </main>
  );
};

export default Dashboard;
